import './TransformPage.pcss';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormGroup } from 'reactstrap';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { RouterComponentProps } from '../../../../../../../common/helpers/routes/interfaces';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import modalActions from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import {
  activeChatbotIdSelector,
  selectCompanies,
} from '@mm/state/selectors/viewSelectors';
import {
  EnhancedBillingPage,
  PageBillingType,
} from '@mm/state/interfaces/connected-page';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import SelectorWithArrow from '../../../../../../../common/components/SelectorWithArrow/SelectorWithArrow';

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouterComponentProps;

type OuterProps = {
  facebookPageName: string;
  facebookPageId: number;
  companyId: number;
};

type Props = OuterProps & InnerProps;

const TransformPage = (props: Props) => {
  const {
    companies,
    companyId,
    activeUserId,
    connectedPage,
    activateCompany,
    facebookPageName,
    openDowngradeFacebookPageModal,
    moveFacebookPage,
    fetchBasicPageList,
    facebookPageId,
    history,
    botId,
  } = props;

  const [disclaimerChecked, setDisclaimerChecked] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<number | undefined>(
    undefined,
  );

  const onTransferClick = async () => {
    if (!connectedPage || !selectedCompany) return;

    const company = companies.find(c => c.id === connectedPage.companyId);

    if (!company) {
      return;
    }

    const { pageBillingType } = connectedPage;

    if (
      pageBillingType === PageBillingType.Free ||
      pageBillingType === PageBillingType.LegacyTeam ||
      pageBillingType === PageBillingType.CustomTeam ||
      pageBillingType === PageBillingType.SpecialTeam ||
      pageBillingType === PageBillingType.Team ||
      pageBillingType === PageBillingType.NewTeam
    ) {
      await moveFacebookPage(facebookPageId, selectedCompany, companyId);
      await activateCompany(activeUserId, selectedCompany);
      await fetchBasicPageList(selectedCompany);
      history.push(BotBuilderRoutes.dashboard.getLink({ chatbotId: botId }));
    } else {
      openDowngradeFacebookPageModal(connectedPage);
    }
  };
  const companiesToShow = companies.filter(c => c.id !== companyId);
  return (
    <SettingSection title={`Transfer ${facebookPageName}:`}>
      <CheckBox
        isChecked={disclaimerChecked}
        onToggle={() => setDisclaimerChecked(!disclaimerChecked)}
        label="I understand that moving this Facebook Page to a different Company cannot be undone"
      />
      <FormGroup className="transform-page__sections-wrapper">
        <SelectorWithArrow
          className="transform-page__company-selector"
          defaultLabel="Choose a Company"
          items={companiesToShow}
          selectedItem={companiesToShow.find(c => c.id === selectedCompany)}
          onChange={value => setSelectedCompany(Number(value))}
          buttonText="Transfer Page to this Company"
          buttonAction={onTransferClick}
          buttonDisabled={
            !selectedCompany ||
            companyId === selectedCompany ||
            !disclaimerChecked
          }
        />
      </FormGroup>
    </SettingSection>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  openDowngradeFacebookPageModal: (page: EnhancedBillingPage) =>
    dispatch(
      modalActions.openDowngradeFacebookPageModal({
        page,
        downgradeType: 'transfer',
      }),
    ),
  moveFacebookPage: (
    facebookPageId: number,
    selectedCompany: number,
    companyId: number,
  ) =>
    dispatch(
      connectedPageCRUDActions.moveToCompany(
        facebookPageId,
        selectedCompany,
        companyId,
      ),
    ),
  activateCompany: (entityId: number, id: number) =>
    dispatch(usersCRUDActions.updateActiveCompanyId(entityId, id)),
  fetchBasicPageList: (companyId: number) =>
    dispatch(
      connectedPageCRUDActions.retrieveBasicListByCompany(
        companyId,
        {
          withFacebookErrors: true,
          withSubscription: true,
        },
        true,
      ),
    ),
});

const mapStateToProps = (state: StoreState) => ({
  connectedPage: activeFacebookPageSelector(state),
  companies: selectCompanies(state),
  botId: activeChatbotIdSelector(state),
  activeUserId: state.session.session.id,
});

const enhance = compose<InnerProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(TransformPage);
